export default __webpack_public_path__ + "static/media/banner9.a1f105ff.JPG";